export default __webpack_public_path__ + "static/media/x_more.33ace241.svg";